import { post } from "@/utils/utils";
import moment from "moment";
 
const screen = {
  state: {
    screenList: [],
    getNumRecordList: [],
    addscreenCode: "",
    editScreenCode: "",
    removeScreenCode: "",
    rowScreen: {}
  },
  mutations: {
    SCREEN_LIST(state, data) {
      state.screenList = data.result;
    },
    ADD_SCREEN_LIST(state, data) {
      state.addScreenCode = data.result.code;
    },
    EDIT_SCREEN_LIST(state, data) {
      state.editScreenCode = data.result.code;
    },
    REMOVE_SCREEN_LIST(state, data) {
      state.removeScreenCode = data.result.code;
    },
    QUERY_ROW_SCREEN(state, data) {
      state.rowScreen = data.result;
    },
    QUERY_GET_NUM_RECORD(state, data) {
      state.getNumRecordList = data.result;
      state.getNumRecordList.list.forEach(v => {
        v.getNumTimeFormat = v.getNumTime
          ? moment(v.getNumTime).format("YYYY-MM-DD hh:mm:ss")
          : "";
        v.callNumTimeFormat = v.callNumTime
          ? moment(v.callNumTime).format("YYYY-MM-DD hh:mm:ss")
          : "";
        v.callTypeFormat = v.callType === 0 ? "预约取号" : "现场取号";
        switch (v.status) {
          case 0:
            v.statusFormat = "等待中";
            break;
          case 1:
            v.statusFormat = "服务中";
            break;

          case 2:
            v.statusFormat = "完成";
            break;
          case 3:
            v.statusFormat = "过号";
            break;
          default:
            break;
        }
      });
    }
  },
  actions: {
    queryScreenList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/screen_info_list`,
        name: "SCREEN_LIST",
        params
      });
    },
    addScreen({ commit }, params) {
      return post({
        commit,
        url: `/server-back/add_screen_config`,
        name: "ADD_SCREEN_LIST",
        params
      });
    },
    editScreen({ commit }, params) {
      return post({
        commit,
        url: `/server-back/edit_screen_config`,
        name: "EDIT_SCREEN_LIST",
        params
      });
    },
    removeScreen({ commit }, params) {
      return post({
        commit,
        url: `/server-back/delete_screen_config`,
        name: "REMOVE_SCREEN_LIST",
        params
      });
    },
    queryRowScreen({ commit }, params) {
      return post({
        commit,
        url: `/server-back/screen_detail`,
        name: "QUERY_ROW_SCREEN",
        params
      });
    },
    queryGetNumRecordList({ commit }, params) {
      return post({
        commit,
        url: `/server-back/callnum_record_list`,
        name: "QUERY_GET_NUM_RECORD",
        params
      });
    }
  }
};

export default screen;
